import { css, keyframes } from '@emotion/react';

export const keyframeslideUpAndFade = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(12px)',
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

export const keyframeslideRightAndFade = keyframes({
  from: {
    opacity: 0,
    transform: 'translateX(-12px)',
  },
  to: {
    opacity: 1,
    transform: 'translateX(0)',
  },
});

export const keyframeslideDownAndFade = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(-12px)',
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

export const keyframeslideLeftAndFade = keyframes({
  from: {
    opacity: 0,
    transform: 'translateX(12px)',
  },
  to: {
    opacity: 1,
    transform: 'translateX(0)',
  },
});

export const styHoverCardContent = css({
  borderRadius: 8,
  backgroundColor: 'var(--background)',
  boxShadow: 'var(--shadow-xl)',
  border: '1px solid var(--border-modal)',
  willChange: 'transform, opacity',
  zIndex: 20,
  "&[data-side='top']": {
    animation: `${keyframeslideDownAndFade} 400ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  "&[data-side='right']": {
    animation: `${keyframeslideLeftAndFade} 400ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  "&[data-side='bottom']": {
    animation: `${keyframeslideUpAndFade} 400ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  "&[data-side='left']": {
    animation: `${keyframeslideRightAndFade} 400ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
});
